import React, { useState, useEffect } from 'react';

const GlobalFooter = () => {
  const [FooterContent, setFooterContent] = useState('');

  useEffect(() => {
    fetch('/lib/foot-v2.txt')
      .then((response) => response.text())
      .then((data) => setFooterContent(data))
      .catch((error) => console.error('Error fetching Footer content:', error));
  }, []);

  return (
    <div dangerouslySetInnerHTML={{ __html: FooterContent }} />
  );
};

export default GlobalFooter;
